import React from 'react';
import camera from 'src/assets/icons/icon-camera.svg';
import cameraOff from 'src/assets/icons/icon-cameraOff.svg';
import microphone from 'src/assets/icons/icon-microphone.svg';
import microphoneOff from 'src/assets/icons/icon-microphoneOff.svg';
import contentShare from 'src/assets/icons/icon-share-screen.svg';
import SettingsIcon from 'src/assets/icons/icon-settings.svg';
import './icons-tray.scss';

interface Props {
  isVideoEnabled: boolean;
  toggleVideo: React.MouseEventHandler<HTMLImageElement>;
  muted: boolean;
  toggleAudioMute: React.MouseEventHandler<HTMLImageElement>;
  toggleContentShareCustom?: (event: React.MouseEvent<HTMLImageElement>) => void;
  setShowModal: (show: boolean) => void;
  leaveMeeting: React.MouseEventHandler<HTMLButtonElement>;
  isTherapist: boolean;
  isFromMeetingRoom?: boolean;
}

const IconsTray: React.FC<Props> = ({
  isVideoEnabled,
  toggleVideo,
  muted,
  toggleAudioMute,
  toggleContentShareCustom,
  setShowModal,
  leaveMeeting,
  isTherapist,
  isFromMeetingRoom = false,
}) => {
  return (
      <div className="icons-row">
        <div className="icons-container">
          <div className="video-icon-container">
            <img
              src={isVideoEnabled ? camera : cameraOff}
              className="video-icon"
              onClick={toggleVideo}
              alt="video icon"
            />
          </div>
          <div className="audio-icon-container">
            <img
              src={muted ? microphoneOff : microphone}
              className="audio-icon"
              onClick={toggleAudioMute}
              alt="audio icon"
            />
          </div>
          {isFromMeetingRoom && <div className="share-icon-container">
            <img
              src={contentShare}
              className="share-icon"
              onClick={toggleContentShareCustom as React.MouseEventHandler<HTMLImageElement>}
              alt="share screen icon"
            />
          </div>}
          <div
            className="cog-icon-container"
            onClick={() => setShowModal(true)}
          >
            <img
              src={SettingsIcon}
              className="audio-icon"
              alt="Settings icon"
            />
          </div>
        </div>
        {isFromMeetingRoom && <div className={'end-session-container'}>
          <button className={'end-session-button'} onClick={leaveMeeting}>
            {isTherapist ? 'End Session' : 'Leave Session'}
          </button>
        </div>}
      </div>
  );
};



export default IconsTray;